<template>
    <div class="row align-items-end">
        <div class="col-xl-3 col-lg-4 col-sm-6">
            <label class="w-100">
                {{ $t('modal.search.placeholder') }}
                <input class="form-control" type="text" v-model="pagination.search" :placeholder="$t('modal.search.placeholder')" @input="searchClients">
            </label>
        </div>
        <div class="col-xl-3 col-lg-4 col-sm-6">
            <label class="w-100">
                {{ $t('modal.form.driver.label') }}
                <v-select class="select-control" v-model="pagination.driver" :options="driverOptions" :reduce="(options) => options.id" label="full_name" @input="fetchData"></v-select>
            </label>
        </div>
        <div class="col-xl-3 col-lg-4 col-sm-6">
            <label class="w-100">
                {{ $t('modal.paginationSize') }}
                <v-select class="select-control" v-model="pagination.pageSize" :options="pageSizeOptions" @input="fetchData"></v-select>
            </label>
        </div>
        <div class="col-xl-3 col-lg-4 col-sm-6 ms-auto">
            <div class="d-flex align-items-center justify-content-end gap-2 flex-wrap mb-2">
                <b-button
                    v-if="checkToggle"
                    variant="success"
                    @click="handleCheckAll"
                >
                    {{ $t('data.checkAll') }}
                </b-button>

                <b-button
                    v-else
                    variant="danger"
                    @click="handleCheckAll"
                >
                    {{ $t('data.uncheckAll') }}
                </b-button>

                <b-button
                    v-if="checkArray.length !== 0"
                    :disabled="db"
                    variant="primary"
                    @click="handleSubmit"
                >
                    {{ $t('modal.button.accept') }}
                </b-button>
            </div>
        </div>
        <div class="col-12 mb-2" v-if="checkRoles">
            <b-button
                variant="primary"
                @click="$router.push({name:'AddClients'})">
                {{ $t('modal.addClients') }}
            </b-button>
        </div>
        <div class="_table">
            <b-table
                :fields="fields"
                :items="cloneItems"
                responsive
                :busy="loading"
            >
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
                <template #cell(created_at)="{item}">
                    <span>{{item.created_at |momentData}}</span>
                </template>
                <template #cell(contract_number)="{item}">
                    <span class="d-flex gap-2 align-items-end">
                          <b-form-checkbox
                              v-model="item.check"
                              :value="true"
                              :unchecked-value="false"
                              @change="handleCheckOnly"
                          />
                      {{ item.contract_number }}
                    </span>
                </template>
                <template #cell(numbers)="{item}">
                  <span
                      v-for="(obj, index) in item.numbers"
                      :key="index"
                  >
                    {{ obj.mobile | VMask('###(##) ### ## ##')}} <br>
                  </span>
                </template>
                <template #cell(actions)="{item}">
                    <b-button size="sm" variant="danger" @click="handleDeleteClient(item)"><i class="bx bx-trash fs-4"></i></b-button>
                  <b-button
                      variant="success"
                      size="sm"
                      @click="putModalOpen(item.id)"
                      v-b-tooltip.hover :title="$t('data.update')"
                  >
                    <i class="bx bx-pencil fs-4"></i>
                  </b-button>
                </template>
            </b-table>
        </div>

        <b-pagination
            v-model="pagination.page"
            :total-rows="total"
            :per-page="pagination.pageSize"
            @input="fetchData"
        ></b-pagination>

        <b-modal v-model="deleteModal.modal" no-close-on-esc no-close-on-backdrop hide-footer hide-header>
            <div class="container-fluid">
                <h5>
                    {{ $t('modal.titleInfoDelete') }}
                </h5>

                <b-button class="float-end ms-3" variant="danger" @click="deleteClient">
                    {{ $t('modal.button.delete') }}
                </b-button>

                <b-button class="float-end" variant="warning" @click="handleDeleteModalClose">
                    {{ $t('modal.button.back') }}
                </b-button>
            </div>
        </b-modal>
      <b-modal
          v-model="putModalBool"
          hide-footer
          :title="$t('modal.titlePut')"
          size="lg"
      >
        <PutModal
            :id="id"
            :branch_options="branch_options"
            :warehouse_options="warehouse_options"
            :lead_options="lead_options"
            :driver_options="driver_options"
            :notify_options="notify_options"
            :clientStatuses="clientStatuses"
            @onClose="putModalClose"
        />
      </b-modal>
    </div>
</template>

<script>
import {getClients, deleteClients, isActivitedClients, getClientStatuses} from '../../../api/endpoints/clients';
import {getDriver} from '../../../api/endpoints/users';
import {mapGetters} from 'vuex';
import moment from "moment";
import {getBranches} from "@/api/endpoints/branches";
import {getWarehouse} from "@/api/endpoints/warehouse";
import {getInfoAll} from "@/api/endpoints/products";
import PutModal from "../../../components/_dispatchers/clients/putModal";

export default {
    name: 'Not-Active-Clinets',
    filters: {
        momentData(date) {
            return moment(date).format('DD-MM-YYYY')
        }
    },
    components: {
      PutModal,
    },
    data() {
        return {
            items: [],
            fields: [
                {
                    key: "contract_number",
                    label: "№"
                },
                {
                    key: "created_at",
                    label: this.$t("table.date"),
                },
                {
                    key: "full_name",
                    label: this.$t("table.full_name.label"),
                },
                {
                    key: "address",
                    label: this.$t("table.address.label"),
                },
                {
                    key: "numbers",
                    label: this.$t("table.numbers.label"),
                },
                {
                    key: "bottles_count",
                    label: this.$t("table.bottles_count")
                },
                {
                    key: "driver.full_name",
                    label: this.$t("table.driver.label"),
                },
                {
                    key: 'actions',
                    label: this.$t('table.actions.label')
                }
            ],
            pagination: {
                page: 1,
                pageSize: 20,
                search: "",
                driver: null,
                is_active: false,
            },
            total: 1,
            driverOptions: [],
            pageSizeOptions: [
                10,
                20,
                50,
                100
            ],
            timeoutForSearchUsers: null,
            checkArray: [],
            computedItems: [],
            checkToggle: true,
            db: false,
            deleteModal: {
                modal: false,
                options: null,
            },
            loading: false,
            putModalBool: false,
            id: null,
            branch_options: [],
            warehouse_options: [],
            lead_options: [],
            driver_options: [],
            clientStatuses: [],
            notify_options: [],
        }
    },
    created() {
        this.fetchData();
        getDriver().then(response => {
            this.driverOptions = response.data.data
        })
    },
    mounted() {
      for (let i = 0; i < 32; i++) {
        this.notify_options.push(i.toString());
      }
      this.fetchStatuses();
      this.getByBranches();
      this.getByWarehouse();
      this.getDriverForSelect();
      this.getProductsOptions();
    },
    computed: {
        ...mapGetters('auth', ['authUser']),
        cloneItems: {
            get() {
                return this.computedItems;
            },
            set(val) {
                this.computedItems = val;
            }
        },
        checkRoles() {
            const user = this.authUser;
            let checkArr = [];
            if(user) {
                user.roles.forEach(val => {
                    if(val.name.toUpperCase() == 'superAdmin'.toUpperCase()) checkArr.push(true)
                })
                if(checkArr.some(item => item == true)) {
                    return true;
                }
            }
            return false;
        },
        checkDeleteClient() {
            return this.deleteModal.options
        }
    },
    methods: {
        fetchData() {
            this.loading = true;
            getClients({...this.pagination}).then(response => {
                this.items = response.data.data;
                this.items.forEach(el => {
                    el.check = false
                })
                this.total = response.data.total;
                this.cloneItems = this.items;
                this.checkArray = [];
            }).finally(() => {
                this.loading = false;
            })
        },
        searchClients() {
            clearTimeout(this.timeoutForSearchUsers);
            this.timeoutForSearchUsers = setTimeout(() => {
                this.fetchData();
            }, 800)
        },
        handleCheckOnly() {
            this.checkArray = this.cloneItems.filter(item => item.check === true).map(val => val.id);
        },
        handleCheckAll() {
            this.checkToggle = !this.checkToggle;
            var newItems = [];
            let template = [...this.cloneItems];
            for (let i = 0; i < template.length; i++) {
                template[i].check = !template[i].check;
                newItems.push(template[i])
            }
            this.cloneItems = newItems;
            this.checkArray = [];
            this.handleCheckOnly();
        },
        handleSubmit() {
            this.db = true;
            setTimeout(() => {
                this.db = false;
            }, 700)
          let data = [];
            this.checkArray.forEach(val => {
              data.push({client_id: val, contract_number: this.items.filter(item => item.id === val)[0].contract_number})
            });
            isActivitedClients({data}).then(() => {
                location.reload();
            })
        },
        handleDeleteClient(item) {
            // eslint-disable-next-line no-console
            console.log(item)
            this.deleteModal.modal = true;
            this.deleteModal.options = item;
        },
        handleDeleteModalClose() {
            this.deleteModal.modal = false;
            this.deleteModal.options = null;
            this.fetchData();
        },
        deleteClient() {
            deleteClients(this.checkDeleteClient.id)
            .then(() => {
                this.handleDeleteModalClose();
            })
        },
      putModalOpen(id) {
        this.id = id;
        this.putModalBool = true;
      },
      fetchStatuses() {
        getClientStatuses().then(res => {
          this.clientStatuses = res.data.data.map(item => Object.assign({}, {value: item.id, label: item.name}));
        })
      },
      getByBranches() {
        getBranches().then((res) => {
          this.branch_options = res.data.data
        });
      },
      getByWarehouse() {
        getWarehouse().then((res) => {
          this.warehouse_options = res.data.data
        });
      },
      getDriverForSelect() {
        getDriver().then((res) => {
          this.driver_options = res.data.data.map((item) =>
              Object.assign({}, {value: item.id, label: item.full_name})
          );
          this.driverOtions = res.data.data;
        });
      },
      getProductsOptions() {
        getInfoAll().then(res => {
          this.products_options = res.data.data.map(item => Object.assign({}, {value: item.id, label: item.name}))
        })
      },
      putModalClose() {
        this.putModalBool = false;
        this.fetchData();
      },
    }
}
</script>
